import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const RETURN_LOCK_HELP: HelpContent[] = [
    {
        helpContentId: 'return-lock.validate-reports',
        tooltipText: 'Use for large batches to validate attachment sizes before starting to lock returns.  Any attachments that are too large for PDF must be formatted as Excel.'
    }
];
